const fr = {
  'INTEGRATIONS.ServiceNow.discovery.CONNECTIONNAME.title':
    'Nom de la source d’identification',
  'INTEGRATIONS.ServiceNow.discovery.USERNAME.title': 'Id de l’utilisateur',
  'INTEGRATIONS.ServiceNow.discovery.INSTANCENAME.title': 'Url de Service Now',
  'INTEGRATIONS.ServiceNow.discovery.PASSWORD.title': 'Mot de passe',
  'INTEGRATIONS.SERVICENOW.URL.VALIDATION_ERROR1': 'Url non valide',
  'INTEGRATIONS.LABEL.DISCOVERY_FREQUENCY': 'Fréquence d’identification',
  'INTEGRATIONS.DESCRIPTION.KBA_PROMPT':
    'Invitez les utilisateurs à répondre à des questions d’authentification basée sur les connaissances (ABC).',
  'INTEGRATIONS.DISCOVERY.DESCRIPTION':
    "Identifiez vos applications et charges de travail via l’une de ces sources d’identification appréciées. Vous bénéficierez de plusieurs avantages, tels que les informations pré-renseignées, les recommandations hiérarchisées ainsi qu''une vue complète du statut d’intégration.",
  'INTEGRATIONS.DISCOVERY.BACK': 'Précédent',
  'INTEGRATIONS.DISCOVERY.TITLE': 'Configurer l’identification',
  'INTEGRATIONS.DISCOVERY.COMINGSOON': 'Prochainement...',
  'INTEGRATIONS.DISCOVERY.LEARNMORE': 'En savoir plus',
  'INTEGRATIONS.DISCOVERY.CONNECTION.APPLICATION.SETUP.DESCRIPTION':
    'Saisissez vos identifiants de l’application pour établir une connexion. Une fois la connexion établie, vous pourrez importer des données.',
  'INTEGRATIONS.DISCOVERY.ERROR.HEADING':
    'Une erreur s’est produite pendant le chargement de la page.',
  'INTEGRATIONS.DISCOVERY.ERROR.SUBHEADING':
    'Essayez de rafraîchir la page ou revenez ultérieurement. Si le problème persiste, contactez votre administrateur.',
  'INTEGRATIONS.DISCOVERY.ERROR.RELOAD': 'Recharger',
  'INTEGRATIONS.ServiceNow.discovery.CONNECTION_SETTINGS.title':
    'Paramètres de connexion',
  'INTEGRATIONS.ServiceNow.discovery.CI_CLASSES.title': 'Classes de CI***',
  'INTEGRATIONS.ServiceNow.discovery.ATTRIBUTE_MAPPING.title':
    'Mappage des attributs',
  'INTEGRATIONS.Feature.Basic.ServiceNow.discovery.Conn.Title':
    'Détails de connexion',
  'INTEGRATIONS.BUTTON.SAVE': 'Enregistrer',
  'INTEGRATIONS.DISCOVERY.SELECT': 'Sélectionner',
  'INTEGRATIONS.DISCOVERY.CREATE_NEW_CONNECTION':
    'Créer une nouvelle connexion',
  'INTEGRATIONS.DISCOVERY.USE_THIS_CONNECTION': 'Utiliser cette connexion',
  'INTEGRATIONS.DISCOVERY.SERVICENOW.SAVED': 'ServiceNow enregistré !',
  'INTEGRATIONS.DISCOVERY.SERVICENOW.SAVED.DESCRIPTION':
    'Votre connexion à la source d’identification ServiceNow a été testée et enregistrée avec succès. Importez des données pour finaliser la configuration de l’identification. Vous pouvez ignorer...',
  'INTEGRATIONS.DISCOVERY.IMPORT': 'Importer des actifs',
  'INTEGRATIONS.DISCOVERY.SKIP_FOR_NOW': 'Ignorer pour l’instant',
  'INTEGRATIONS.DISCOVERY.SERVICENOW.SAVED.INLINE':
    'Une fois que l’importation a commencé, elle ne peut plus être annulée',
  'INTEGRATION.DISCOVERY.SETUP.GUIDE_ME': 'Guidez moi',
  'INTEGRATION.DISCOVERY.SELECT_EXISTING':
    'Sélectionnez une connexion existante',
  'INTEGRATION.DISCOVERY.CONNECTION.NAME': 'Nom de la connexion',
  'INTEGRATION.EXISTING.CONNECTION.SUBTEXT':
    'Nous avons identifié {total, plural, one {une} other {#}} configuration de connexion existante :',
  'INTEGRATIONS.FILEUPLOAD.STARTIMPORT': 'Commencer l’importation',
  'INTEGRATIONS.FILEUPLOAD.IMPORTINGDATA':
    'Importation de données depuis un fichier Excel. Veuillez patienter...',
  'INTEGRATIONS.TRY.AGAIN': 'Réessayer',
  'INTEGRATIONS.CLOSE': 'Fermer',
  'INTEGRATIONS.ERROR.CONNECTION': 'Erreur de connexion. Veuillez réessayer.',
  'INTEGRATIONS.FILEUPLOAD.SUCCESS':
    'Vous pouvez quitter la page pendant que vous patientez. Nous vous avertirons une fois le processus terminé.',
  'INTEGRATIONS.FILEUPLOAD.MODAL.TITLE': 'Importer une source d’identification',
  'INTEGRATIONS.FILEUPLOAD.HEADING':
    'Importez votre source d’identification depuis un fichier',
  'INTEGRATIONS.FILEUPLOAD.DOWNLOAD_SAMPLE':
    'Télécharger un exemple de fichier',
  'INTEGRATIONS.FILEUPLOAD.INPUT_LABEL': 'Nom de la source d’identification',
  'INTEGRATIONS.FILEUPLOAD.INPUT_PLACEHOLDER': 'Saisissez le nom du fichier',
  'INTEGRATIONS.FILEUPLOAD.INVALID_NAME':
    'Veuillez saisir un nom valide. Seuls les lettres, les nombres et les symboles de sélection sont autorisés.',
  'INTEGRATIONS.FILEUPLOAD.UPLOADING': 'En cours de chargement...',
  'INTEGRATIONS.FILEUPLOAD.CONTINUE': 'Continuer',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.TITLE':
    'Voici les 10 premiers enregistrements chargés depuis le fichier XLSX.',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.ALERT.MISSING_HEADER':
    'En-tête obligatoire manquant',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.ALERT.COLUMN_ERRORS_SUFFIX':
    'Erreurs détectées dans la colonne',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.ALERT.FIX_ISSUES':
    'Veuillez corriger les erreurs avant de poursuivre l’importation des données.',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.EXCLUDE': 'Exclure de l’importation',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.TITLE':
    'Confirmation d’intégration de l’application',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.DESCRIPTION':
    "Nous avons identifié le type d’application. Veuillez confirmer que vous êtes en train d''intégrer le type d’application approprié.",
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.DEFAULT_APP_DESC':
    "Le type d’application que vous êtes en train d'intégrer est {applicationName}",
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.SELECT_DIFFERENT':
    'Non, sélectionnez-la sans une liste d’applications',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.CONFIRM':
    'Oui, je suis en train de l’intégrer',
  'INTEGRATIONS.DASHBOARD.HEADER.TITLE': 'Intégrations',
  'INTEGRATIONS.DASHBOARD.HEADER.ADD_INTEGRATION': 'Ajouter une intégration',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.SEARCH': 'Aucun résultat trouvé pour',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.FILTER': 'Non',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.FILTER.SUFFIX': 'intégrations trouvées.',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.HIDDEN':
    'Aucune intégration masquée disponible.',
  'INTEGRATIONS.DASHBOARD.APPLICATIONS_DISCOVERED': 'Applications identifiées',
  'INTEGRATIONS.DASHBOARD.OWNER_LABEL': 'Propriétaire :',
  'INTEGRATIONS.DASHBOARD.LAST_DISCOVERED': 'Date de dernière identification :',
  'INTEGRATIONS.DASHBOARD.CONNECTION_FAILED': 'La connexion a échoué',
  'INTEGRATIONS.DASHBOARD.USERS_HAVE_ACCESS':
    'Les utilisateurs bénéficient de l’accès',
  'INTEGRATIONS.DASHBOARD.CHIP_DISCOVERY_SOURCE': 'Source d’identification',
  'INTEGRATIONS.BUTTON.ENABLE': 'Activer',
  'INTEGRATIONS.BUTTON.DISABLE': 'Désactiver',
  'INTEGRATIONS.ENABLING': 'Activation',
  'INTEGRATIONS.MODAL_TITLE.DISCOVERY': 'Identification',
  'INTEGRATIONS.DASHBOARD.REUPLOAD': 'Charger à nouveau',
  'INTEGRATIONS.DASHBOARD.ONBOARD': 'Intégrer',
  'INTEGRATIONS.DASHBOARD.HIDE': 'Masquer',
  'INTEGRATIONS.DASHBOARD.UNHIDE': 'Afficher',
  'INTEGRATIONS.DISCOVERY.TABS_ARIA_LABEL':
    'Onglets de configuration de l’identification',
  'INTEGRATIONS.DISCOVERY.DISCARD_UNSAVED_CHANGES_TITLE':
    'Supprimer les modifications non enregistrées ?',
  'INTEGRATIONS.DISCOVERY.DISCARD_UNSAVED_CHANGES_SUBTITLE':
    'Vous avez des modifications non enregistrées. Les modifications seront perdues si vous continuez.',
  'INTEGRATIONS.BUTTON.DISCARD_CHANGES': 'Supprimer les modifications',
  'INTEGRATIONS.BUTTON.CANCEL': 'Annuler',
  'INTEGRATIONS.BUTTON.SAVE_ERROR_TITLE': 'Erreur d’enregistrement',
  'INTEGRATIONS.CMDB_HEADER.BACK_BUTTON_ARIA_LABEL':
    'Revenir à la page précédente',
  'INTEGRATIONS.CMDB_HEADER.IMAGE_ALT': 'Icône de l’application',
  'INTEGRATIONS.CMDB_HEADER.RUN_MANUALLY_BUTTON': 'Exécuter manuellement',
  'INTEGRATIONS.CMDB_HEADER.ALERT.DISABLE_FAILED_TITLE':
    'Échec de la désactivation',
  'INTEGRATIONS.CMDB_HEADER.ALERT.ENABLE_FAILED_TITLE': 'Échec de l’activation',
  'INTEGRATIONS.CMDB_HEADER.ALERT.DISABLE_SUCCESS_DESCRIPTION':
    'Désactivation effectuée avec succès.',
  'INTEGRATIONS.CMDB_HEADER.ALERT.ENABLE_SUCCESS_DESCRIPTION':
    'Activation effectuée avec succès.',
  'INTEGRATION.DISCOVERY.SETUP.SERVICENOW.JOBCONFLICT':
    'Une autre importation est actuellement en cours.',
  'INTEGRATION.DISCOVERY.SETUP.SERVICENOW.JOBCONFLICT.SUBHEADING':
    "Les actifs sont actuellement en cours d''importation par un autre processus. Veuillez réessayer ultérieurement.",
  'INTEGRATION.DISCOVERY.SETUP.SERVICENOW.IMPORTFAILED':
    'Échec de l’importation',
  'INTEGRATIONS.DISCOVERY.IMPORTINGASSETS':
    'Importation d’actifs depuis ServiceNow',
  'INTEGRATIONS.DISCOVERY.IMPORTINGASSETS.MESSAGE':
    'Vous pouvez quitter la page pendant que vous patientez. Nous vous avertirons une fois le processus terminé.',
  'INTEGRATIONS.ATTRIBUTE_MAPPINGS.BUTTON.ADD_ROW_ARIA_LABEL':
    'Ajouter une nouvelle ligne de mappage des attributs',
  'INTEGRATIONS.ATTRIBUTE_MAPPINGS.BUTTON.ADD_ATTRIBUTE': 'Ajouter un attribut',
  'INTEGRATIONS.ATTRIBUTE_ROW.EMPTY_PLACEHOLDER': '(Vierge)',
  'INTEGRATIONS.ATTRIBUTE_ROW.DELETE_ARIA_LABEL': 'Supprimer ce mappage',
  'INTEGRATIONS.ATTRIBUTE_ROW.HEADER.SERVICENOW_FIELD': 'Champ ServiceNow',
  'INTEGRATIONS.ATTRIBUTE_ROW.HEADER.SAVIYNT_FIELD': 'Champ Saviynt',
  'INTEGRATIONS.ATTRIBUTE_DROPDOWN.SEARCH_SERVICENOW':
    'Rechercher un attribut ServiceNow',
  'INTEGRATIONS.ATTRIBUTE_DROPDOWN.SEARCH_SAVIYNT':
    'Rechercher un attribut Saviynt',
  'INTEGRATIONS.ATTRIBUTE_DROPDOWN.CUSTOM_SUFFIX': '(Personnaliser)',
  'INTEGRATIONS.ERROR.SAVE_FAILED': 'Échec de l’enregistrement',
  'INTEGRATIONS.SCHEDULING.ARIA_LABEL': 'Programmation de la configuration',
  'INTEGRATIONS.SCHEDULING.REPEATS_AT': 'à {timeLabel} UTC.',
  'INTEGRATIONS.SCHEDULING.REPEAT_ON_TITLE': 'Répéter le',
  'INTEGRATIONS.SCHEDULING.REPEAT_ON_DAYS_GROUP': 'Répéter les',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.LABEL.REPEAT_EVERY': 'Répéter chaque',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.PLACEHOLDER.ENTER_INTERVAL':
    'Saisissez un intervalle',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.ARIA_LABEL.REPEAT_INTERVAL':
    'Intervalle de répétition en nombre de jours, de semaines ou de mois',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.UNIT.DAY': 'Jour',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.UNIT.WEEK': 'Semaine(s)',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.UNIT.MONTH': 'Mois',
  'INTEGRATIONS.DAYS.SUN': 'Dim',
  'INTEGRATIONS.DAYS.MON': 'Lun',
  'INTEGRATIONS.DAYS.TUE': 'Mar',
  'INTEGRATIONS.DAYS.WED': 'Mer',
  'INTEGRATIONS.DAYS.THU': 'Jeu',
  'INTEGRATIONS.DAYS.FRI': 'Ven',
  'INTEGRATIONS.DAYS.SAT': 'Sam',
  'INTEGRATIONS.BUTTON.DISABLING': 'Désactivation',
  'INTEGRATIONS.BUTTON.SAVED': 'Enregistré',
  'INTEGRATIONS.BUTTON.SAVING': 'Enregistrement',
  'INTEGRATIONS.DISABLE_MODAL.ALERT_TITLE': 'Voulez-vous vraiment désactiver ',
  'INTEGRATIONS.DISABLE_MODAL.ALERT_SUBTITLE':
    'Désactiver la source d’identification interrompt l’importation des actifs et vous empêche de configurer la source.',
  'INTEGRATIONS.DISCOVERY.HERE': 'ici',
  'INTEGRATIONS.DISCOVERY.EXISTING.CONNECTION.FAILED':
    'Votre source d’identification a été créée avec succès mais la connexion à ServiceNow a échoué. Pour commencer à importer des actifs, veuillez actualiser les informations de connexion sur la page de configuration de la source d’identification. ',
};

export default fr;
